<div class="ostso-dialog landmark">
  <div class="header">
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
    <h1>{{ isNew ? "Создание подразделения" : "Редактирование подразделения" }}</h1>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">
      <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Структурное подразделение">


      <pas-multi-select3 [formControlName]="'indicators'"
                         title="Показатель"
                         [customDataService]="indicatorService"
                         [options]="{pageSize: 1e6}"
                         customDialogMethod="apiIndicatorGet"
                         type="checkbox"
      >
        <ng-template #listItem let-item>
          {{ item.name }} ({{item.shortName}}), (ID:{{ item.id }}), ({{item.period.name}})
        </ng-template>
        <ng-template #dialogList let-item>
          {{ item.name }} ({{item.shortName}}), (ID:{{ item.id }}), ({{item.period.name}})
        </ng-template>
      </pas-multi-select3>

      <br/>

    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="!form.valid">Применить</button>
    <button class="btn btn-secondary" mat-button (click)="onReset()">Сбросить</button>
  </div>
</div>

